import React, { useState, Fragment } from 'react'
import { Form } from 'informed'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Text, Checkbox, Select, Number as NumberInput } from 'components/forms'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { Add } from 'media/icons'
import { getProduct_Ingrs, listIngredients } from '../../../gql/query'
import styles from '../ingredients.module.scss'

const IngredientDetails = ({ ingredientGroup, mutateProduct, mutateIngr, mutationIngrName, ingrData, productIngrs, closeForm, product }) => {
	const [isAddingNewIngr, setIsAddingNewIngr] = useState(false)
	const [selectedIngredient, setSelectedIngredient] = useState(null)
	const [t] = useTranslation()

	const onCloseForm = () => {
		setIsAddingNewIngr(false)
		closeForm()
	}
	const isMutationUpdate = ingrData.productIngrId
	const showAdditionalFields = isAddingNewIngr && ingrData.id < 0
	const productId = product.id
	const isMarkupIngredient = selectedIngredient ? !selectedIngredient.units : !ingrData.units

	const handleSubmit = values => {
		const { id, ingredientId, amount, contains } = values
		const ingredient = { ...values.ingredient || {} }
		const prodIngrFields = {
			...ingredientId && { ingredientId },
			...amount && { amount },
			contains: !!contains
		}
		if(!isAddingNewIngr) {
			if(id) {
				prodIngrFields.id = id
			}
			mutateProduct({ ingredients: [prodIngrFields] }, {
				refetchQueries: [{
					query: getProduct_Ingrs,
					variables: { id: productId }
				}]
			})
		} else {
			mutateIngr({
				variables: {
					required: { productId },
					fields: {
						...prodIngrFields,
						ingredient
					}
				},
				refetchQueries: [{
					query: listIngredients,
					variables: { type: ingredientGroup }
				}, {
					query: getProduct_Ingrs,
					variables: { id: productId }
				}]
			})
		}
		onCloseForm()
	}

	return(
		<div className={classNames('theme-light', styles['form-container'])}>
			<p className={styles.title}>
				{t(`product_section.strings.${ingredientGroup === 'nutrients' ? 'nutrients' : 'allergens'}`)} {t('product_section.strings.add')}
			</p>
			<Divider height={34} visible inverted className={styles.divider} />
			<Form initialValues={ingrData} onSubmit={handleSubmit}>
				{({ formApi, formState }) => (
					<Fragment>
						<Select disabled={true} field='ingredient.group' label={t('product_section.strings.group')} inverted
							options={[
								{ label: t('product_section.strings.nutrients'), value: 'nutrients' },
								{ label: `${t('product_section.strings.nutrients') + 'EU'}`, value: 'allergens_EU' }
							]}
						/>
						<div className={styles['add-container']}>
							{showAdditionalFields ?
								<Text field='ingredient.name' label={t('product_section.fields.name')} /> :
								<Select
									field='ingredientId'
									label={t('product_section.fields.name')}
									validate={val => {
										// Don't validate field if it's has not changed
										if(Number(val) === Number(ingrData.ingredientId)) {
											return
										}
										const isAlreadyInProduct = productIngrs.find(({ ingredientId, contains }) => ingredientGroup === 'allergens_EU' ?
											Number(ingredientId) === Number(val) && contains
											:
											Number(ingredientId) === Number(val)
										)
										if(isAlreadyInProduct) {
											return t('product_section.strings.ingr_in_product')
										}
									}}
									onChange={setSelectedIngredient}
									labelField='name'
									remoteOptions={{ query: listIngredients, variables: { type: ingredientGroup } }}
									validateOnChange
									valueField='id' />
							}
							<div>
								{ingrData.id < 0 &&
									<div className={styles['add-btn']} onClick={e => setIsAddingNewIngr(true)}>
										<Add />
									</div>
								}
							</div>
						</div>
						{ingredientGroup === 'nutrients' && !isMarkupIngredient && <NumberInput field='amount' label={t('common.fields.quantity')} precision={3} step={0.001} inline shrink/>}
						{ingredientGroup === 'allergens_EU' &&
							<Checkbox field='contains' label={t('product_section.fields.contains')} disabled />
						}
						{showAdditionalFields && (
							<Fragment>
								<Text field='ingredient.code' label={t('product_section.fields.number')} inline shrink />
								<Select field='ingredient.units' label={t('product_section.fields.units')} inline shrink
									options={[
										{ label: 'µ/100g', value: 'µ/100g' },
										{ label: 'mg/100g', value: 'mg/100g' },
										{ label: 'KJ', value: 'KJ' },
										{ label: 'kcal', value: 'kcal' },
										{ label: 'g/100g', value: 'g/100g' }
									]}
								/>
								<Text field='ingredient.keyword' label={t('product_section.fields.keyword')} inline shrink/>
							</Fragment>
						)}
						<Text field='id' hidden />
						<div>
							<Button
								shrink
								type='submit'
								status={((formApi.getValue('ingredientId') > 0 || formApi.getValue('ingredient.name')) && formApi.getValue('ingredient.group')) ? 'primary' : 'inactive'}
								text={isMutationUpdate ? t('common.buttons.save') : t('common.buttons.add')} />
							<Button shrink text={t('common.buttons.cancel')} status='cancelation' onClick={e => onCloseForm()} />
						</div>
					</Fragment>
				)}
			</Form>
		</div>
	)
}

export default IngredientDetails
